import {
  EntityInformation,
  RegionProfiling,
} from '@amzn/awsdev-docs-virtual-smiley-typescript-client';
import { Table, TableProps } from '@amzn/awsui-components-react/polaris';
import { ReactElement } from 'react';

const regionProfiles = Object.values(RegionProfiling);

const columnDefinitions: TableProps.ColumnDefinition<EntityInformation>[] = [
  {
    id: 'entityId',
    header: 'ID',
    cell: ({ service }) => service?.entityId ?? '-',
  },
  ...regionProfiles.map(
    (p): TableProps.ColumnDefinition<EntityInformation> => ({
      id: p,
      header: p,
      cell: ({ service }) =>
        service?.value?.[p]?.value.map((s) => s.value).join(' ') || '-',
    })
  ),
];

export const Entable = ({
  entities,
}: {
  entities: EntityInformation[];
}): ReactElement => (
  <Table
    variant='embedded'
    columnDefinitions={columnDefinitions}
    items={entities}
  />
);
